// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__17ixm","head":"ProcedureTableInfo_head__3hwDy"};